var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-white" },
    [
      _c(
        "div",
        { staticClass: "h48 pl24 c-cC26 yxtbiz-signup-manage-info__title" },
        [_vm._v("\n    " + _vm._s(_vm.language().lbl_baseInfo) + "\n  ")]
      ),
      _c(
        "div",
        { staticClass: "ph24 pv24 yxtbiz-signup-manage-info__content" },
        [
          _c("div", { staticClass: "flex-1" }, [
            _c("div", { staticClass: "content-row" }, [
              _c("div", { staticClass: "content-col w100p" }, [
                _c("span", { staticClass: "c-cC8C" }, [
                  _vm._v(_vm._s(_vm.language().lbl_signupName) + "："),
                ]),
                _c("span", { staticClass: "c-cC26" }, [
                  _vm._v(_vm._s(_vm.projectInfo.projectName)),
                ]),
              ]),
              _c("div", { staticClass: "content-col" }, [
                _c("span", { staticClass: "c-cC8C" }, [
                  _vm._v(_vm._s(_vm.language().lbl_historySignup) + "："),
                ]),
                _c("span", { staticClass: "c-cC26" }, [
                  _vm._v(
                    _vm._s(_vm.statisticsInfo.signedCount || 0) +
                      "/" +
                      _vm._s(_vm.statisticsInfo.historicalSignedCount || 0)
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "content-row" }, [
              _c(
                "div",
                { staticClass: "content-col w100p" },
                [
                  _c("span", { staticClass: "c-cC8C" }, [
                    _vm._v(
                      _vm._s(_vm.language().lbl_registration_status) + "："
                    ),
                  ]),
                  _vm.staus[_vm.projectInfo.projectStatus]
                    ? _c(
                        "yxt-tag",
                        {
                          attrs: {
                            type: _vm.staus[_vm.projectInfo.projectStatus].type,
                            size: "mini",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.staus[_vm.projectInfo.projectStatus].text
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("div", { staticClass: "content-col" }, [
                _c("span", { staticClass: "c-cC8C" }, [
                  _vm._v(_vm._s(_vm.language().lbl_to_be_reviewed) + "："),
                ]),
                _c("span", { staticClass: "c-cC26" }, [
                  _vm._v(_vm._s(_vm.statisticsInfo.waitAuditCount || 0) + " "),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "content-row" }, [
              _c("div", { staticClass: "content-col w100p" }, [
                _c("span", { staticClass: "c-cC8C" }, [
                  _vm._v(_vm._s(_vm.language().lbl_signupTimes) + "："),
                ]),
                _vm.projectInfo.startTime && _vm.projectInfo.endTime
                  ? _c("span", { staticClass: "c-cC26" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.projectInfo.startTime) +
                          "~" +
                          _vm._s(_vm.projectInfo.endTime) +
                          "\n            "
                      ),
                    ])
                  : _c("span", { staticClass: "c-cC26" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.language().msg_long_term) +
                          "\n            "
                      ),
                    ]),
              ]),
              _c("div", { staticClass: "content-col" }, [
                _c("span", { staticClass: "c-cC8C" }, [
                  _vm._v(_vm._s(_vm.language().lbl_official_quota) + "："),
                ]),
                _c("span", { staticClass: "c-cC26" }, [
                  _vm._v(_vm._s(_vm.statisticsInfo.formalCount || 0) + " "),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "content-row" }, [
              _c(
                "div",
                { staticClass: "content-col w100p" },
                [
                  _c("span", { staticClass: "c-cC8C" }, [
                    _vm._v(_vm._s(_vm.language().lbl_signupUrl) + "："),
                  ]),
                  _c("span", { staticClass: "c-cC26" }, [
                    _vm._v(_vm._s(_vm.projectInfo.shortUrl)),
                  ]),
                  _c(
                    "yxt-button",
                    {
                      staticClass: "ml8",
                      attrs: { type: "text" },
                      on: { click: _vm.copyUrl },
                    },
                    [
                      _c("yxt-svg", {
                        staticStyle: { transform: "translateY(3px)" },
                        attrs: {
                          width: "16px",
                          height: "16px",
                          "remote-url":
                            _vm.$staticBaseUrl + "assets/8c7d1ef0/a224517d",
                          "icon-class": "file",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.projectInfo.formalQuota !== 0
                ? _c("div", { staticClass: "content-col" }, [
                    _c("span", { staticClass: "c-cC8C" }, [
                      _vm._v(
                        _vm._s(_vm.language().lbl_substitute_quota) + "："
                      ),
                    ]),
                    _c("span", { staticClass: "c-cC26" }, [
                      _vm._v(
                        _vm._s(_vm.statisticsInfo.replacementCount || 0) + " "
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "pr hand" }, [
            _vm.projectInfo.shortUrl
              ? _c(
                  "div",
                  {
                    on: {
                      click: function ($event) {
                        _vm.qrCodeVisible = true
                      },
                    },
                  },
                  [
                    _c("yxtbiz-qrcode", {
                      attrs: {
                        size: 96,
                        url: _vm.projectInfo.shortUrl,
                        "hide-link": true,
                        "hide-download": true,
                        padding: 0,
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "text-center mt8 font-size-12 lh20 c-cC26",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.language().lbl_projectqrcode) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
      _c(
        "yxt-dialog",
        {
          attrs: {
            "append-to-body": true,
            visible: _vm.qrCodeVisible,
            cutline: false,
            width: "410px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.qrCodeVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _c(
              "div",
              { staticClass: "mt8 mb16" },
              [
                _c("yxtbiz-qrcode", {
                  attrs: {
                    url: _vm.projectInfo.shortUrl,
                    size: 200,
                    "hide-link": false,
                    "hide-download": false,
                    name: _vm.projectInfo.projectName,
                    "is-project": "",
                    "project-tip": _vm.language().lbl_projectqrcode,
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }